import { FontWeightEnum, TextVariantColorEnum } from '@app/common';
import { BreakpointSizeType } from '../theme/type/breakpoints-type';
import { GapSizeType } from '../theme/type/gap-type';
import { TextSizeType, TextVariantType } from '../theme/type/text-type';

export const cn = (...values: Array<string | false | null | undefined>) => values.filter(Boolean).join(' ');

export const breakpointPrefix: Record<BreakpointSizeType, string> = {
    xs: 'xs:',
    vs: 'vs:',
    sm: 'sm:',
    md: 'md:',
    lg: 'lg:',
    vl: 'vl:',
    xl: 'xl:',
    xxl: 'xxl:',
    fullhd: 'fullhd:',
};

export const gapClass: Record<GapSizeType, string> = {
    none: '0',
    xxsmall: 'xxsmall',
    xsmall: 'xsmall',
    vsmall: 'vsmall',
    small: 'small',
    medium: 'medium',
    large: 'large',
    vlarge: 'vlarge',
    xlarge: 'xlarge',
    xxlarge: 'xxlarge',
};

export const marginTopClass: Record<GapSizeType, string> = {
    none: '',
    xxsmall: 'mt-xxsmall',
    xsmall: 'mt-xsmall',
    vsmall: 'mt-vsmall',
    small: 'mt-small',
    medium: 'mt-medium',
    large: 'mt-large',
    vlarge: 'mt-vlarge',
    xlarge: 'mt-xlarge',
    xxlarge: 'mt-xxlarge',
};

export const marginBottomClass: Record<GapSizeType, string> = {
    none: 'mb-0',
    xxsmall: 'mb-xxsmall',
    xsmall: 'mb-xsmall',
    vsmall: 'mb-vsmall',
    small: 'mb-small',
    medium: 'mb-medium',
    large: 'mb-large',
    vlarge: 'mb-vlarge',
    xlarge: 'mb-xlarge',
    xxlarge: 'mb-xxlarge',
};

export const marginLeftClass: Record<GapSizeType, string> = {
    none: '',
    xxsmall: 'ml-xxsmall',
    xsmall: 'ml-xsmall',
    vsmall: 'ml-vsmall',
    small: 'ml-small',
    medium: 'ml-medium',
    large: 'ml-large',
    vlarge: 'ml-vlarge',
    xlarge: 'ml-xlarge',
    xxlarge: 'ml-xxlarge',
};

export const marginRightClass: Record<GapSizeType, string> = {
    none: '',
    xxsmall: 'mr-xxsmall',
    xsmall: 'mr-xsmall',
    vsmall: 'mr-vsmall',
    small: 'mr-small',
    medium: 'mr-medium',
    large: 'mr-large',
    vlarge: 'mr-vlarge',
    xlarge: 'mr-xlarge',
    xxlarge: 'mr-xxlarge',
};

export const textSizeClass: Record<TextSizeType, string> = {
    xsmall: 'text-xsmall',
    vsmall: 'text-vsmall',
    small: 'text-small',
    medium: 'text-medium',
    large: 'text-large',
    vlarge: 'text-vlarge',
    xlarge: 'text-xlarge',
    xxlarge: 'text-xxlarge',
};

export const textVariantClass: Record<TextVariantType, string> = {
    default: 'text-text',
    inverse: 'text-text-inverse',
    primary: 'text-brand-primary',
    secondary: 'text-brand-secondary',
    positive: 'text-status-positive',
    negative: 'text-status-negative',
    warning: 'text-status-warning',
    gray: 'text-neutral-gray',
    white: 'text-neutral-white',
    black: 'text-neutral-black',
    blue: 'text-[#3347FF] dark:text-[#33B6FF]',
    purple: 'text-[#6A6FF9]',
    green: 'text-[#15BE96]',
};

export const commonTextVariantClass: Record<TextVariantColorEnum, string> = {
    [TextVariantColorEnum.Default]: textVariantClass.default,
    [TextVariantColorEnum.Inverse]: textVariantClass.inverse,
    [TextVariantColorEnum.Primary]: textVariantClass.primary,
    [TextVariantColorEnum.Secondary]: textVariantClass.secondary,
    [TextVariantColorEnum.Positive]: textVariantClass.positive,
    [TextVariantColorEnum.Negative]: textVariantClass.negative,
    [TextVariantColorEnum.Warning]: textVariantClass.warning,
    [TextVariantColorEnum.Gray]: textVariantClass.gray,
    [TextVariantColorEnum.White]: textVariantClass.white,
    [TextVariantColorEnum.Black]: textVariantClass.black,
};

export const fontWeightClass: Record<FontWeightEnum, string> = {
    [FontWeightEnum.Thin]: 'font-normal',
    [FontWeightEnum.Medium]: 'font-medium',
    [FontWeightEnum.SemiBold]: 'font-bold',
    [FontWeightEnum.Bold]: 'font-black',
};

export const alignClass = (align: string) => {
    switch (align) {
        case 'left':
            return 'text-left';
        case 'center':
            return 'text-center';
        case 'right':
            return 'text-right';
        case 'justify':
            return 'text-justify';
        default:
            return '';
    }
};
